import '../css/main.css';
import './custom';

import Masonry from 'masonry-layout';
import axios from "axios";

$(document).ready(function () {
    //AJAX ARTICLES
    if($('.js-posts-grid').length) {
        new Masonry( '.js-posts-grid', {
            itemSelector: '.posts__list-item'
        });

        $('.js-posts-more').on('click', function(e) {
            e.preventDefault();

            var url = $(this).data('url');
            if (url !== undefined && url !== "") {
                $.ajax({
                    url: "/ajax/get-news.php" + url,
                    method: 'GET',
                    success: function(posts) {
                        let gridElement = document.querySelector('.js-posts-grid');
                        gridElement.insertAdjacentHTML('beforeend', posts);

                        let msnry = new Masonry( '.js-posts-grid', {
                            itemSelector: '.posts__list-item'
                        });

                        msnry.appended(posts);
                        msnry.layout();

                        var newUrl = $(".articles.posts .posts__footer .js-posts-more").data('url');
                        if (newUrl == undefined) {
                            $(".content__page > .posts__footer").remove();
                        }else{
                            $(".articles.posts .posts__footer .js-posts-more").remove();
                            $(".content__page > .posts__footer .js-posts-more").data('url', newUrl);
                        }
                    }
                });
            }
        });
    }

    //Добавление товаров в корзину из старого заказа
    $('.download-file__input1').on('change', function (){
        if (window.FormData === undefined) {
            alert('В вашем браузере FormData не поддерживается')
        } else {
            var formData = new FormData(),
                fileExtended = $(this).parent().data('type') == 'extended' ? 'Y' : 'N',
                success = '',
                error = '';
            formData.append('file', $(this)[0].files[0]);
            formData.append('extended', fileExtended);

            axios.post(
                '/api/cart/load/excel',
                formData,
                {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'X-Requested-With': 'XMLHttpRequest',

                    }
                }
            ).then(function (response) {
                if (response.data.status == true) {
                    success = 'Успешно добавлено ' + response.data.result.count;
                } else {
                    error = 'С ошибками: ' + response.data.message;
                }

                let cart = response.data.result.basket;

                $('#result').html(success);
                $('#error').html(error);
                $('.download-file__error').show();

                $('#text_count').html(cart.count);

                $('#loading').hide();
                $('#results').show();

                localStorage.setItem('igr_basket', JSON.stringify({value: cart, expire: null}));
                document.dispatchEvent(new CustomEvent("updateBasket", {detail: cart}));
            })
            .catch(function (error) {
                let errorTxt = 'Произошли ошибки при загрузке файла'
                $('#error').html(errorTxt);
                $('.download-file__error').show();
                console.log(error);
            });
        }
    });

    $('.action-link').on('click', function () {
        $('#results').hide();
        $('#form').show();
    });

    var s = window.matchMedia("screen and (max-width: 767px)"),
        a = window.matchMedia("screen and (max-width: 1199px)");
    window.matchMedia("screen and (max-width: 1019px)");

    $(".navigation-left__list-item").each(function () {
        $(this).find(".navigation-left__submenu").length && ($(this).prepend('<span class="arrow-toggle"></span>'), $(this).addClass("has-submenu"))
    });
    $(".arrow-toggle").on("click", function (e) {
        e.preventDefault(), $(this).parent().toggleClass("opened")
    });
    jQuery(function (e) {
        e.fn.defaultValue = function () {
            return this.each(function () {
                var t = e(this).val(), i = e(this);
                i.focus(function () {
                    i.val() == t && e(this).val("")
                }), i.blur(function () {
                    0 == i.val().length && i.val(t)
                })
            })
        };
        e('.slider-range input[type="text"], .price-range input[type="text"]').defaultValue()
    });
    $(".city-toggle__dropdown").on("click", function (e) {
        e.preventDefault(), $(this).parent().toggleClass("opened")
    });
    $(document).click(function (e) {
        if ($(".city-toggle").hasClass("opened")) {
            if ($(e.target).closest(".city-toggle").length) return;
            $(".city-toggle").removeClass("opened"), e.stopPropagation()
        }
    });
    $(".js-grid-view").on("click", function (e) {
        e.preventDefault(), $(".view-template__button").removeClass("active"), $(this).addClass("active"), $(".catalog__list .product").removeClass("product_view_list").addClass("product_view_box")
    });

    $(".js-view-all-haracteristik").on("click", function (e) {
        e.preventDefault();
        var t = $(this).parent();
        t.hasClass("show") ? (t.removeClass("show"), $(this).find(".action-link__text").text("Все характеристики")) : (t.addClass("show"), $(this).find(".action-link__text").text("Скрыть характеристики"))
    });
    $(".js-navigation-btn-mobile").on("click", function (e) {
        e.preventDefault(), $(".navigation-left").removeClass("open"), $(this).parent().toggleClass("open")
    });
    $(".js-navigation-btn-dropdown").on("click", function (e) {
        e.preventDefault(), $(".navigation").removeClass("open");
        var t = $(this).parent();
        t.hasClass("open") ? t.removeClass("open") : t.addClass("open")
    });
    $(document).click(function (e) {
        if ($(".navigation-left").hasClass("open")) {
            if ($(e.target).closest(".navigation-left").length) return;
            $(".navigation-left").removeClass("open"), e.stopPropagation()
        }
    });
    $(".tabs-default__navigation-link").on("click", function (e) {
        e.preventDefault();
        var t = $(this), i = t.parent().parent(), a = t.attr("data-toggle");
        if (i.find(".tabs-default__box").removeClass("active"), i.find(".tabs-default__navigation-link").removeClass("active"), t.addClass("active"), i.find('.tabs-default__box[data-id="' + a + '"]').addClass("active"), s.matches) {
            var n = this.offsetLeft - (window.innerWidth - this.offsetWidth) / 2;
            document.querySelector(".tabs-default__navigation").scrollLeft = n
        }
    });
    $(".js-search-btn-mobile").on("click", function (e) {
        e.preventDefault(), $(this).parent().toggleClass("open")
    });
    $(".js-faq").on("click", function (e) {
        e.preventDefault();
        var t = $(this).parent().parent();
        t.hasClass("open") ? t.removeClass("open") : ($(".js-faq").parent().parent().removeClass("open"), t.addClass("open"))
    });

    var validateEmail = function(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    var validatePhone = function(phone) {
        var re = /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{3,10}$/;
        return re.test(phone);
    };

    $('.form_feedback').submit(function(e){
        var form = $(this),
            text = form.find('input[data-required="text"]'),
            phone = form.find('input[data-required="tel"]'),
            email = form.find('input[data-required="email"]'),
            errorFlag1 = false,
            errorFlag2 = false,
            errorFlag3 = false,
            data = form.serialize(),
            url = form.attr('action');

        e.preventDefault();

        if(text.length) {
            if(text.val() == '') {
                form.find('input[data-required="text"]').closest('.form-data__parametr').addClass('error');
                errorFlag1 = true;
            } else {
                form.find('input[data-required="text"]').closest('.form-data__parametr').removeClass('error');
                errorFlag1 = false;
            }
        }

        if(email.length) {
            if (!validateEmail(email.val())) {
                form.find('input[data-required="email"]').closest('.form-data__parametr').addClass('error');
                errorFlag2 = true;
            } else {
                form.find('input[data-required="email"]').closest('.form-data__parametr').removeClass('error');
                errorFlag2 = false;
            }
        }

        if(phone.length) {
            if ( !validatePhone(phone.val()) || phone.val() == '' ) {
                form.find('input[data-required="tel"]').closest('.form-data__parametr').addClass('error');
                errorFlag3 = true;
            } else{
                form.find('input[data-required="tel"]').closest('.form-data__parametr').removeClass('error');
                errorFlag3 = false;
            }
        }

        if (!errorFlag1 && !errorFlag3) {
            $.ajax({
                url: url,
                type: "post",
                dataType: "text",
                data: data,
                success: function (ans) {
                    $('.form_feedback')[0].reset();

                    if(form.hasClass('form_feedback_promo')) {
                        form.parent().parent().parent().addClass('success');
                    } else {
                        form.addClass('success');
                    }
                },
                error: function (ans) {
                    $('.form_feedback')[0].reset();

                    if(form.hasClass('form_feedback_promo')) {
                        form.parent().parent().parent().addClass('success');
                    } else {
                        form.addClass('success');
                    }
                }
            });
        }
    });

    $('body').on('click', '.navigation-actions__item', function () {
        $(this).find('.dropdown__content').css('position', 'absolute').toggle();
    });

    //Табы на главной. ТМ и Лицензии
    $(".tabs").length && $(".tabs").find(".tabs__underline").css("width", $(".tabs__navigation-item.active").outerWidth());
    $(".tabs__navigation-item").on("click", function (e) {
        e.preventDefault();

        $(this).parent().parent().find(".tabs__underline").css("width", $(".tabs__navigation-item.active").outerWidth());
        $(this).parent().parent().find(".tabs__box").removeClass("active");
        $(this).parent().parent().find(".tabs__navigation-item").removeClass("active");
        $(this).addClass("active");
        $(this).parent().parent().find('.tabs__box[data-id="' + $(this).attr("data-toggle") + '"]').addClass("active");
        $(this).parent().parent().find(".tabs__underline").css("left", $(this).position().left);
        $(this).parent().parent().find(".tabs__underline").css("width", $(this).outerWidth());
        $(this).parent().parent().find(".active .swiper-container-horizontal").length && $(this).parent().parent().find(".active .js-promo-carousel")[0].swiper.update()
    });

    $('body').on('click', '.event__close', function () {
        $('.events').fadeOut("slow");
    });

    //Footer
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('.scrollup').fadeIn();
        } else {
            $('.scrollup').fadeOut();
        }
    });

    $('.scrollup').click(function () {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

    //ЛК
    $(".send-button").on('click', function (e) {
        e.preventDefault();

        var mess = $('.message-text').val();

        $(this).attr('disabled', 'disabled');

        $.ajax({
            type: "POST",
            url: "/ajax/send.php",
            data: "message=" + mess,
            success: function (msg) {
                var res = msg.replace(/\r|\n/g, '');
                $('.alert').fadeOut();

                if (res == 'OK') {
                    $('.message-form').addClass('hidden');
                    $('.alert-success').removeClass('hidden');
                } else if (res == 'NODATA') {
                    $('.message-text').css('border', 'solid 1px red');
                    $('.alert-warning').text('Необходимо ввести сообщение.').removeClass('hidden');
                } else {
                    $('.alert-danger').text(res).removeClass('hidden');
                }
                $('.send-button').removeAttr('disabled');
            },
            error: function (err) {
                $('.message-form').addClass('hidden');
                $('.alert-danger').text('ERROR: ' + err).removeClass('hidden');
                $('.send-button').removeAttr('disabled');
            }
        });
    });
});